/**
 * Aggregates Time Log rows by (every selected field except duration_minutes)
 * and SUMS the duration_minutes field. Used when the user wants a
 * consolidated "total hours per team member per project" view.
 *
 * Auto-applied when:
 *   - `time_logs` is in selectedModules
 *   - `time_logs.duration_minutes` is in selectedFields
 *   - `time_logs.date` is NOT in selectedFields
 *
 * Returns the original rows unchanged if any condition fails.
 */
export function aggregateTimeLogs(rows, selectedModules, selectedFields) {
  const hasTimeLogs = selectedModules.includes('time_logs');
  const hasDuration = selectedFields.includes('time_logs.duration_minutes');
  const hasDate = selectedFields.includes('time_logs.date');
  if (!hasTimeLogs || !hasDuration || hasDate) return rows;

  const groups = new Map();
  rows.forEach((row) => {
    const keyParts = selectedFields
      .filter((f) => f !== 'time_logs.duration_minutes')
      .map((f) => `${f}=${row[f] ?? ''}`);
    const key = keyParts.join('|');
    if (!groups.has(key)) {
      groups.set(key, { ...row, 'time_logs.duration_minutes': 0 });
    }
    const existing = groups.get(key);
    existing['time_logs.duration_minutes'] += Number(row['time_logs.duration_minutes']) || 0;
  });
  return Array.from(groups.values());
}

/**
 * True iff the current selection should show the "aggregation in effect" banner.
 */
export function isTimeLogAggregationActive(selectedModules, selectedFields) {
  return (
    selectedModules.includes('time_logs') &&
    selectedFields.includes('time_logs.duration_minutes') &&
    !selectedFields.includes('time_logs.date')
  );
}
